import { Component, OnInit } from '@angular/core';

import { AppStatisticalFormUser } from 'src/app/core/types/app-statistical-form-user.type';

@Component({
    selector: 'app-current-organization-complex-statistics',
    templateUrl: './current-organization-complex-statistics.component.html',
    styleUrls: ['../../base/base-statistics-reports.scss'],
    standalone: false
})
export class CurrentOrganizationComplexStatisticsComponent implements OnInit {

  title:string="pages.currentOrganizationComplexStatistics.title";
  getComplexStatisticsApiMethodName:string="statisticsGetCurrentOrganizationComplexStatistics";
  getDetailComplexStatisticsApiMethodName:string="statisticsGetDetailCurrentOrganizationComplexStatistics";
  lineComplexChartId: string = "lineComplex_currentOrganizationComplexStatistics";
  barComplexChartId: string = "barComplex_currentOrganizationComplexStatistics";
  userType: AppStatisticalFormUser = "currentOrganizationUsersList";
  constructor() { }

  ngOnInit(): void {
  }
}
